"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _PDFControlPanel = _interopRequireDefault(require("./PDFControlPanel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PDFControl = exports.PDFControl = function PDFControl(_ref) {
  var program = _ref.program,
    onSourceChanged = _ref.onSourceChanged;
  var pdfLayer = (0, _react.useMemo)(function () {
    return program.layers.find(function (layer) {
      return [_constants.PDF_FILE].includes(layer.source.type);
    });
  }, [program]);
  if (!pdfLayer) return null;
  var pdfSource = pdfLayer.source;
  var activePage = pdfSource.value.activePage;
  var onPageClick = function onPageClick(pageNumber) {
    pdfSource.value.activePage = pageNumber;
    onSourceChanged(pdfSource._id, pdfSource.value);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "pdf-control"
  }, /*#__PURE__*/_react["default"].createElement(_PDFControlPanel["default"], {
    onPageClick: onPageClick,
    pdfSource: pdfSource.value.url,
    activePage: activePage ? activePage : 1
  }));
};
PDFControl.propTypes = {
  program: _propTypes["default"].object.isRequired,
  onSourceChanged: _propTypes["default"].func.isRequired
};